import { render } from "./LevensverhalenTwa.vue?vue&type=template&id=024dd193&scoped=true"
import script from "./LevensverhalenTwa.vue?vue&type=script&lang=js"
export * from "./LevensverhalenTwa.vue?vue&type=script&lang=js"

import "./LevensverhalenTwa.vue?vue&type=style&index=0&id=024dd193&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024dd193"]])

export default __exports__